import Data from 'react-k2-api/Api/Data'
import PrimaryKey from 'react-k2-api/Api/PrimaryKey'
import { Type } from 'class-transformer'
import TProductKeyDM from './TProductKeyDM'
import TArticleDM from './TArticleDM'

/**
 * Bonusový sortiment
 */
export default class TLoyaltyProgramSpecificationDM extends Data {
	public static className = 'TLoyaltyProgramSpecificationDM'
	public static primaryKey = 'RID'
	public static systemFields = [
		'RecordID',
	]

	public getPrimaryKey(): PrimaryKey {
		return this.RID!
	}

	public static isHeader = false

	/**
	 * Počet bodů
	 */
	Quantity?: number

	/**
	 * Pořadí
	 */
	SequenceNumber?: number

	/**
	 * Věrnostní program
	 */
	LoyaltyProgramId?: number

	/**
	 * Číslo
	 */
	RID?: number

	/**
	 * undefined
	 */
	RecordMod?: number

	/**
	 * undefined
	 */
	RecordES?: number

	/**
	 * Číslo
	 */
	RecordID?: number

	/**
	 * undefined
	 */
	RecordState?: number

	/**
	 * s
	 */
	SelectionImgCalc?: string

	/**
	 * LegislationContext
	 */
	LegislationContextCalc?: number

	/**
	 * Datum
	 */
	CurrentDateCalc?: Date

	/**
	 * Čas
	 */
	CurrentTimeCalc?: Date

	/**
	 * Produktový klíč
	 */
	@Type(() => TProductKeyDM)
	ProductKeyId?: TProductKeyDM

	/**
	 * Zboží
	 */
	@Type(() => TArticleDM)
	ArticleId?: TArticleDM
}